export default {"src":"/_next/static/media/image5.b5a2701c.svg","height":235,"width":320,"blurWidth":0,"blurHeight":0};